import { distinctUntilChanged, MonoTypeOperatorFunction } from 'rxjs';
import { IMessage } from '../message';

/**
 * @returns
 * Operator that emits if the array of messages has changed
 */
export function distinctMessages<
  T extends IMessage,
>(): MonoTypeOperatorFunction<T[]> {
  return distinctUntilChanged((a, b) => {
    if (a.length !== b.length) {
      return false;
    }

    const keys = b.map(({ key }) => key);
    return !a.some(({ key }) => !keys.includes(key));
  });
}
